/*
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 用户相关信息
 * @Date: 2021-09-09 15:21:20
 * @LastEditTime: 2021-11-04 10:44:52
 */
/*
 * @Author: 徐吉文
 * @LastEditors: 徐吉文
 * @description: 应用状态管理
 * @Date: 2021-07-20 10:23:19
 * @LastEditTime: 2021-07-20 10:34:19
 */


// 应用状态
const state = () => {
  return {
    order:{
      orderId: '',
      platform: null,
      appId: null,
      status: null,
      region: null,
      dateTime: null,
      task:null
    },
    appInfo:{}
  };
};
  
// getters
const getters = {
  
}
// 操作管理
const mutations = {
  setOrderRegion(s, payload) {
    s.order.region = JSON.parse(JSON.stringify(payload))
  },
  setOrderAppId(s, payload) {
    s.order.appId = JSON.parse(JSON.stringify(payload))
  },
  setOrderDate(s, payload) {
    s.order.dateTime = payload
  },
  setOrderStatus(s, payload) {
    s.order.status = JSON.parse(JSON.stringify(payload))
  },
  setOrderStore(s, payload) {
    s.order.platform = JSON.parse(JSON.stringify(payload))
  },
  setOrderTask(s, payload) {
    s.order.task = JSON.parse(JSON.stringify(payload))
  },
  clearOrderForm(s, payload){
    Object.keys(s.order).forEach(key=>s.order[key]=payload)
  },
  setAppInfo(s, payload) {
    Object.assign(s.appInfo,JSON.parse(JSON.stringify(payload)))
  },
  clearMyAppInfo(s, payload){
    s.appInfo=payload
  }
    
};
const actions = {
    
};
  
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
  